import React from 'react';


const Overview = () => {
  return (
<>
{/* <h6
  style={{
    textAlign: "left",
    fontSize: "1.8rem",
    backgroundColor: "rgb(202, 217, 239)",
    fontWeight: "bold",    
    padding: "0.5rem 1rem",
    borderRadius: "6px",
    marginBottom: "1rem",
  }}
>
Overview:
</h6> */}

<h3> The tropical depression/cyclone is situated at (latitude and longitude) in the southern Indian Ocean. which has been moving at a speed of 6 km/hr for the past 6 hours and is expected to intensify further as it moves to the southwest of the Timor Sea.</h3>
</>
  );
};

export default Overview;
